import { render, staticRenderFns } from "./passengerFlowDistribution.vue?vue&type=template&id=3549c6c5&scoped=true&"
import script from "./passengerFlowDistribution.vue?vue&type=script&lang=js&"
export * from "./passengerFlowDistribution.vue?vue&type=script&lang=js&"
import style0 from "./passengerFlowDistribution.vue?vue&type=style&index=0&id=3549c6c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549c6c5",
  null
  
)

export default component.exports